import React from 'react';
import styled from 'styled-components';

import loader from '../assets/img/loader.svg';

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 0;

  ${({ isFullscreen }) => isFullscreen ? `
    background: rgba(0,0,0,.8);
    flex-flow: column;
    font-weight: 500;
    color: #fff;
    font-size: 1.3em;
  ` : ''}
`;

const Loader = ({ isFullscreen = true, children, translate }) => (
  <Wrapper isFullscreen={isFullscreen}>
    <img src={loader} alt={translate('please_wait')} />
    {children}
  </Wrapper>
);

export default Loader;
